/* globals SYS_CONST, alert, RSAKey, WsStore, I18N_CONST */
/* eslint-disable camelcase */

require('jquery');

var Components = require('./components');
var Handlebars = require('./hbshelper');
var TwoFactoryVerify = require('./twofactorverify');
var QRCode = require('qrcode');
var io = require('socket.io-client');
var PollStore = require('common/pollstore');
var loginDeviceStore = require('./loginDeviceStore');
var Cookie = require('cookie');
var ConfirmBox = require('cui/ui/dialog/confirmbox');
var Detector = require('util/detector');

require('common/wsstore');

require('script-loader!jsbn');
require('script-loader!jsbn/jsbn2');
require('script-loader!jsbn/prng4');
require('script-loader!jsbn/rng');
require('script-loader!jsbn/rsa');
require('script-loader!jsbn/rsa2');

// hardcode rsa加密解密必要条件
var rsa_n = 'C4E3F7212602E1E396C0B6623CF11D26204ACE3E7D26685E037AD2507DCE82FC\n28F2D5F8A67FC3AFAB89A6D818D1F4C28CFA548418BD9F8E7426789A67E73E41';
var rsa_e = '10001';
var rsa_d = '7cd1745aec69096129b1f42da52ac9eae0afebbe0bc2ec89253598dcf454960e\n3e5e4ec9f8c87202b986601dd167253ee3fb3fa047e14f1dfd5ccd37e931b29d';
var rsa_p ='f0e4dd1eac5622bd3932860fc749bbc48662edabdf3d2826059acc0251ac0d3b';
var rsa_q = 'd13cb38fbcd06ee9bca330b4000b3dae5dae12b27e5173e4d888c325cda61ab3';
var rsa_dmp1 = 'b3d5571197fc31b0eb6b4153b425e24c033b054d22b9c8282254fe69d8c8c593';
var rsa_dmq1 = '968ffe89e50d7b72585a79b65cfdb9c1da0963cceb56c3759e57334de5a0ac3f';
var rsa_coeff = 'd9bc4f420e93adad9f007d0e5744c2fe051c9ed9d3c9b65f439a18e13d6e3908';
var rsa_password_prefix = 'password: ';

var $loginForm;     // 登录表单元素
var _$;             // $loginForm 下查询节点，具有缓存
var __$;            // $loginForm 下查询节点，无缓存

// 二次验证相关变量
var secondAuthMeta = SYS_CONST.secondAuthMeta;
var isUseSecondAuth = secondAuthMeta.sms || secondAuthMeta.dynamic1 || secondAuthMeta.dynamic2;
var isNeedToBindSecondAuth = !(secondAuthMeta.config === 'none' || secondAuthMeta.config === 'custom');

// 是否是 IE7 及 IE7 以下的低版本
var isLowerVersion = Detector.isIE('7-');

// 统一管理各cookie 名
var cookieNames = {
    uid:                'uid',                  // uid
    saveUsername:       'saveUsername',         // 保存用户名
    domain:             'domain',               // 邮箱域名
    face:               'face',                 // 风格
    locale:             'locale',               // 语言
    netSpeedServerHost: 'netSpeedServerHost',   // 服务器加速
    portinfo:           'portinfo'              // 端口
};
var cookieOptions = {expires : 30, path : '/'};

window.SYS_CONST = window.SYS_CONST || {};

initCDNCSSload();

Components.blurBgImg();

renderContent();

initFormQueryHelpers();

// 事件绑定
//window.setTimeout(function(){
//    initEventDelegate();
//}, 50);
initEventDelegate();

initErrorMsg();
// 获取天气情况
initWeather();
// Cookie 值自动填充
autoFillCookieValue();

// 低版本提示
if (isLowerVersion) {
    notifyLowVersionWarning(isUseSecondAuth ? I18N_CONST.msg_low_version_second_auth : I18N_CONST.msg_low_version);
}

$(document).customRadioCheckbox();

function initCDNCSSload() {
    if (SYS_CONST.imgCDN || false) {
        $('body').addClass('cdn');
    }
}

function notifyLowVersionWarning(message, callback) {
    callback = callback || $.noop;

    var title = I18N_CONST.msg_sys_info;
    var handler = function () {
        this.hide();
        this.destroy();
        callback();
    };

    new ConfirmBox({
        parentNode: $('.main'),
        title: title,
        message: message,
        confirmTpl: I18N_CONST.msg_low_version_confirm,
        cancelTpl: false,
        onConfirm: handler,
        onCancel: handler
    }).show();
}

function renderContent() {
    var data = window.DATA || {};

    // handlebar编译
    // content部分
    var template = Handlebars.compile($('#contentTpl').html());
    var result = template(data);
    $('.main .content').html(result);
    // aside部分
    var template2 = Handlebars.compile($('#asideTpl').html());
    var result2 = template2(data);
    $('.main .aside').html(result2);

    if (isUseSecondAuth) {
        TwoFactoryVerify.initVerify({
            backObserver: function() {
                submitWithoutLogin();
                return false;
            },
            authData: SYS_CONST.secondAuthMeta,
            $authWrap: $('.j-second-auth-wrap'),
            $loginForm: $('.j-login-form')
        });
    }
}

/**
 * 创建具有返回结果缓存效果的函数
 *
 * @param {function} fn 原始函数
 * */
function cached(fn) {
    var cache = {};
    return function cacheFn(str) {
        var hit = cache[str];
        return hit == null ? (cache[str] = fn(str)) : hit;
    }
}

// 初始化表单元素以及相关的DOM 查询函数
function initFormQueryHelpers() {
    $loginForm = $('.j-login-form');

    __$ = function queryUnderLoginForm(selector) {
        return $loginForm.find(selector);
    };

    _$ = cached(__$);
}

// 触发登录表单提交
function triggerLoginFormSubmit() {
    $loginForm.submit();
}

function initEventDelegate () {
    $('.loginArea').on('click', '[role="dropdown"]', function(evt) {
        var menu = $(this).find('.u-menu');
        if (!menu.hasClass('u-menu-show')) {
            $('.u-menu').removeClass('u-menu-show').addClass('u-menu-hidden');
        }
        menu.toggleClass('u-menu-hidden u-menu-show');
        evt.stopPropagation();
    }).on('click', 'a[logintype]', function() {
        var loginType = $(this).attr('logintype');
        var container = $(this).closest('.loginArea');
        var curLoginType = container.attr('curtype');
        if (loginType !== curLoginType) {
            container.toggleClass(curLoginType + ' ' +loginType)
                    .attr('curtype', loginType)
        }

        if (loginType === 'QRCode' && SYS_CONST.appScanLogin.enable) {
            createQRCode();
            subscribeQRLoginMsg();
        }
    }).on('click', '.backToScan', function() {
        updateQRLoginContainer('waitScan');
    }).on('click', '.headImage i', function() {
        // 重载页面
        location.reload();
    });

    $('.u-menu').on('click', 'li', function(evt) {
        var parentNode = $(this).closest('[role="dropdown"]');
        parentNode.find('li .iconfont').remove();
        $(this).addClass('u-menu-choose').append('<i class="iconfont iconchoose left"></i>');
        if (parentNode.hasClass('locale')) { // 语言菜单
            $('#locale').val($(this).data('locale'));
            Cookie.set(cookieNames.locale, $(this).data('locale'), cookieOptions);
            submitWithoutLogin();
        } else if (parentNode.hasClass('faceMenu')) { // 风格菜单
            _$('.faceTxt').html($(this).data('facetxt'));
            _$('#faceName').val($(this).data('facetxt'));
            _$('#face').val($(this).data('face'));
        } else if (parentNode.hasClass('domainMenu')) { // 域名菜单
            _$('.domainTxt').html($(this).data('domain'));
            _$('#domain').val($(this).data('domain'));
        }
        $(this).closest('.u-menu').removeClass('u-menu-show').addClass('u-menu-hidden');
        evt.stopPropagation();
    });

    $('[data-operation]').on('click', function () {
        var operation = $(this).data('operation');
        switch (operation) {
        case 'addFavourite' :
            try {
                window.external.AddFavorite(location.href, document.title);
                $(this).addClass('favourite');
            } catch (e) {
                try {
                    window.sidebar.addPanel(location.href, document.title, '');
                    $(this).addClass('favourite');
                } catch (e) {
                    alert($(this).data('msg'));
                }
            }
            break;
        case 'refresh' :
            var imgObj = $('.securityCode img');
            var url = imgObj.attr('src');
            var rand = parseInt(Math.random()*100000000);
            url = url.replace(/rand=-?\d*/, 'rand=' + rand);
            imgObj.attr('src', url);
            break;
        case 'recoverPwdUrl' :
            var pwdUrl = $(this).attr('href');
            var uid = _$('#uid').val();
            if (uid) {
                var index = pwdUrl.indexOf('?');
                if (index !== -1) {
                    var hostPart = pwdUrl.substr(0, index);
                    var paramPart = pwdUrl.substr(index + 1);
                    var paramPartArr = paramPart.split('&');
                    var newParamPart = ''; // 拼凑新的请求字符串
                    var i ,str;
                    for (i = 0; i < paramPartArr.length; i++) {
                        str = paramPartArr[i];
                        if (str.indexOf('uid') !== -1) {
                            var arr = str.split('=');
                            arr[1] = uid;
                            newParamPart += arr[0] + '=' + arr[1] + '&';
                        } else {
                            newParamPart += str + '&';
                        }
                    }
                    // 去掉最后的&
                    newParamPart = newParamPart.substr(0, newParamPart.length - 1);
                    $(this).attr('href', hostPart + '?' + newParamPart);
                } else {
                    pwdUrl += '?uid=' + uid;
                    $(this).attr('href', pwdUrl);
                }
            }
            break;
        }
    });

    _$('.inputArea').on('focus', 'input', function () {
        $(this).closest('.input-wrapper').prev().addClass('actived');
    }).on('err.focus', 'input', function () {
        $(this).trigger('focus');
        $(this).closest('.input-wrapper').prev().addClass('error');
        if ($(this).attr('id') === 'uid') {
            $('.forPassword label').addClass('error');
        }
    }).on('blur', 'input', function () {
        $(this).closest('.input-wrapper').prev().removeClass('error actived');
    });

    $(document).on('click', '[role!="dropdown"]', function() {
        $('.u-menu').removeClass('u-menu-show').addClass('u-menu-hidden');
    });

    $('.j-ssl-login-button').on('click', function() {
        var action = $loginForm.attr('action');
        location.href = 'https://' + location.hostname + (location.port !== 80 ? ':' + location.port : '') + action.replace(/index.jsp.*/, 'index_ca.jsp');
    });

    // “登录”按钮点击
    _$('.j-submit').on('click', function () {
        preLogin(doLogin);
    });

    _$('#useSSL').on('change.crc', function() {
        if ($(this).prop('disabled')) return;

        setTimeout(function() {
            preLogin(submitWithoutLogin);
        }, 10);
    });

    // ie8/ie9 在登录页按回车会默认触发form的submit()，这里直接捕获回车
    $loginForm.on('keypress', function (e) {
        var keyCode = e.keyCode ? e.keyCode : e.which ? e.which : e.charCode;
        if (keyCode === 13) {
            _$('.j-submit').trigger('click');
            return false;
        } else { return true; }
    });
}

function initWeather() {
    $.ajax({
        type: 'GET',
        url: '/@context.name@/XT5/jsp/mail.jsp',
        data: {func: 'getWeather'},
        dataType: 'json',
        success: function(data) {
            if (data.code !== 'S_OK') {
                return;
            }
            var status = data['var']['weather']['status'];
            if (status === 'success') {
                var weatherResults = data['var']['weather']['results'][0];
                var currentCity = weatherResults['currentCity'];
                var currentWeather = weatherResults['weather_data'][0];
                var temperature = currentWeather['temperature'];
                var dayPic = currentWeather['dayPictureUrl'];
                var nightPic = currentWeather['nightPictureUrl'];

                $('#weatherInfo').html(temperature + ' | ' + currentCity);
                var weatherPic;
                if (new Date().getHours() >= 18) {
                    weatherPic = nightPic.substring(nightPic.lastIndexOf('/') + 1, nightPic.lastIndexOf('.'));
                } else {
                    weatherPic = dayPic.substring(dayPic.lastIndexOf('/') + 1, dayPic.lastIndexOf('.'));
                }
                $('#weatherPic').addClass('icon' + weatherPic);
                $('#weather').show();
            } else {
                $('#weather').hide();
            }
        },
        error: function() {
            //$("#mainRight #weather").hide();
        }
    });
}

function autoFillCookieValue () {
    var domain = Cookie.get(cookieNames.domain) || '';
    var uid = Cookie.get(cookieNames.uid) || '';
    if (domain.length > 0) {
        // 选中cookie对应domain
        _$('[data-domain="'+ domain +'"]').trigger('click');
        uid = uid.split('@')[0];
    }

    if (uid.length > 0) {
        _$('#uid').val(uid);
    }

    var saveUserName = Cookie.get(cookieNames.saveUsername) || '';
    if (_$('#saveUsername').length) {
        _$('#saveUsername').prop('checked', saveUserName === 'true');
    }

    var face = Cookie.get(cookieNames.face) || '';
    if (face.length > 0) {
        // 选中cookie对应的face
        _$('[data-face="'+ face +'"]').trigger('click');
    }

    if (SYS_CONST.enablePasswordKey && SYS_CONST.encryptHash) {
        var rsa = new RSAKey();
        rsa.setPrivateEx(rsa_n, rsa_e, rsa_d, rsa_p, rsa_q, rsa_dmp1, rsa_dmq1, rsa_coeff);
        var decodeHash = rsa.decrypt(SYS_CONST.encryptHash);
        _$('#fakePassword').val(decodeHash.substr(rsa_password_prefix.length));
    }
}

function initErrorMsg () {
    var focusEleName = SYS_CONST.focusEleName,
        empty_error = SYS_CONST.empty_error,
        error_other = SYS_CONST.error_other;

    var focusInp, $panel;

    if (focusEleName === 'password' && SYS_CONST.enablePasswordKey) {
        focusInp = _$('#fakePassword');
    } else {
        focusInp = _$('[name="'+ focusEleName +'"]');
    }
    if (focusInp.length !== 0) { // 输入框抖动
        if (empty_error || error_other) {
            // IE678用js实现抖动效果
            focusInp.trigger('err.focus');
            $panel = focusInp.parents('.u-form-item');
            shakeInput($panel);
        } else {
            focusInp.trigger('focus');
        }
    }
}

/**
 * CM-24043: 登录页路由功能
 * 根据uid 以及lookup 配置，查询登录路由
 *
 * @param {function} err 查询失败回调
 * @param {function} next 查询成功回调
 * */
function doDomainLookup(err, next) {
    var lookupAction = SYS_CONST.lookupPath;
    var lookupDomain = SYS_CONST.lookupDefaultDomain;

    var $uid = _$('#uid');
    var uid = $uid.val();
    var fullUid = genUidWithDomain(uid);
    var useSSL = _$('#useSSL').prop('checked') || false;

    if (!$.isFunction(err)) err = $.noop;
    if (!$.isFunction(next)) err = $.noop;

    // path 配置不正确，跳过路由查询
    if (typeof lookupAction !== 'string') return next();

    // uid 为空，跳过路由查询
    if (!fullUid.length) {
        return next();
    }

    // 如果此时，uid 无域名后缀，则尝试从LookupDefaultDomain 中查找，如果都找不到，则报错
    if (!checkUidWithDomain(fullUid)) {
        if (lookupDomain.length) {
            fullUid = uid + '@' + lookupDomain;
        } else {
            showInputError($uid);
            shakeInput($uid);
            showErrMsgInfo(SYS_CONST.loginErrIncompleteEmail);
            return err(SYS_CONST.loginErrIncompleteEmail);
        }
    }

    var resultMsg = null;
    var rqData = {
        'uid': fullUid,
        'useSSL': useSSL,
        'forAdmin': false,
        'type': 'jsonp'
    };

    $.ajax({
        url: lookupAction,
        type: 'GET',
        dataType: 'jsonp',
        jsonp:'callback',
        data: rqData,
        timeout: 5000,
        success:function(json) {
            var url = json;
            if (!url) {
                showInputError($uid);
                shakeInput($uid);
                resultMsg = SYS_CONST.loginErrUnknownEmail;
            } else if (url === 'LOAD_FAILED') {
                resultMsg = SYS_CONST.loginErrLookupLoadFailed;
            } else if (url.match(/^ERROR:/)) {
                resultMsg = url.substring('ERROR:'.length);
            }

            if (resultMsg) {
                showErrMsgInfo(resultMsg);
                err(resultMsg);
            } else {
                // 这里遵从原来的实现，利用lookupCallback 来实现单层的路由查找
                if (url.indexOf('?') !== -1) {
                    url = url + '&lookupCallback=1';
                } else {
                    url = url + '?lookupCallback=1';
                }
                next(url);
            }
        },
        error: function() {
            resultMsg = 'Unknown error';
            showErrMsgInfo(resultMsg);
            err(resultMsg);
        }
    });
}

/**
 * 预登录
 *
 * 这里主要是处理登录表单的输入参数
 * */
function preLogin(next) {
    if ((isUseSecondAuth || isNeedToBindSecondAuth) && isLowerVersion) {
        // 若用户启用了二次验证或系统需要强制绑定二次验证，低版本浏览器进行提示并取消登录过程
        notifyLowVersionWarning(I18N_CONST.msg_low_version_second_auth);
        return;
    }

    cleanErrMsgInfo();

    next = next || $.noop;

    var self = $loginForm;
    var isWarning = false;
    var useSSL = _$('#useSSL').prop('checked') || false;
    var $face = _$('#face');
    var face = $face.val();

    /**
     * RSA 密码处理
     *
     * @param {string} action 登录表单的action
     * */
    var formatPasswordKey = function(action) {
        if (SYS_CONST.enablePasswordKey) {
            var password = _$('#fakePassword').val();
            var publicKey_e = SYS_CONST.publicKey_e;
            var publicKey_n = SYS_CONST.publicKey_n;
            var rsa;
            if (password) {
                rsa = new RSAKey();
                rsa.setPublic(rsa_n, rsa_e);
                var encryptHash = rsa.encrypt(rsa_password_prefix + password);
                if (action.indexOf('?') === -1) {
                    action += '?hash=' + encryptHash;
                } else {
                    action += '&hash=' + encryptHash;
                }
            }
            // 使用wmsvr传递的公钥加密密码
            if (publicKey_e && publicKey_n && password) {
                rsa = new RSAKey();
                rsa.setPublic(publicKey_n, publicKey_e);
                // 加密后的密码填充至需要提交的密码框
                _$('#password').val(rsa.encrypt(password));
            }
        }
        return action;
    };

    /**
     * 格式化表单action
     * 根据是否勾选ssl 来更改action 的协议值
     *
     * @param {string} action 登录表单的action
     * */
    var formatFormAction = function(action) {
        var srcProtocol = useSSL ? 'http://' : 'https://';
        var dstProtocol = useSSL ? 'https://' : 'http://';

        action = translateProtocol(action, srcProtocol, dstProtocol);
        self.attr('action', action);
    };

    var loginAction = function() {
        var formAction = self.attr('action');

        // 允许更换服务器
        // todo: 这里选择的服务器会被下面的路由所覆盖，需要确认
        if (SYS_CONST.enableSpeedTest) {
            var savedNetHost = Cookie.get(cookieNames.netSpeedServerHost);
            if (savedNetHost) {
                var netHostAction = location.protocol + '//' + savedNetHost;
                if (location.pathname) {
                    netHostAction += location.pathname;
                }

                formAction = netHostAction;
            }
        }

        if (SYS_CONST.lookupPath) {
            doDomainLookup(function(/*errMsg*/) {
                return false;
            }, function(url) {
                if (typeof url === 'string' && url.length) {
                    formAction = url;
                }
                formatFormAction(formatPasswordKey(formAction));
                next();
            });
        } else {
            formatFormAction(formatPasswordKey(formAction));
            next();
        }
    };

    if (face === 'auto') {
        // IE7 以下强制使用 XT3
        face = isLowerVersion ? 'XT3' : Cookie.get(cookieNames.face) || 'XT5';
    }

    if (face === 'XT5' && isLowerVersion) {
        // 正常登录模式下，若选择了 XT5 则进行提示
        notifyLowVersionWarning(I18N_CONST.msg_low_version, loginAction);
        isWarning = true;

        face = 'XT3';
    }
    $face.val(face);
    Cookie.set(cookieNames.face, face, cookieOptions);

    var $locale = _$('#locale');
    if ($locale.length > 0) {
        Cookie.set(cookieNames.locale, $locale.val(), cookieOptions);
    }

    var $uid = _$('#uid');
    $uid.val(formatUid($uid.val()));

    var saveUserName = _$('#saveUsername').length ? _$('#saveUsername').prop('checked') : false;
    if (saveUserName) {
        Cookie.set(cookieNames.saveUsername, true, cookieOptions);
        Cookie.set(cookieNames.uid, genUidWithDomain($uid.val()), cookieOptions);
        var $domain = _$('#domain');
        if ($domain.length > 0) {
            Cookie.set(cookieNames.domain, $domain.val(), cookieOptions);
        }
    } else {
        Cookie.remove(cookieNames.saveUsername, {path : '/'});
        Cookie.remove(cookieNames.uid, {path : '/'});
    }

    !isWarning && loginAction();
}

/**
 * 最后触发登录事件前还允许做一些表单数据处理
 * 这里建议进行非用户输入的数据处理
 * */
function doLogin() {
    var $uid = _$('#uid');
    var uid = $uid.val();
    uid = genUidWithDomain(formatUid(uid));

    (function collectLoginDeviceInfo() {
        if (!SYS_CONST.supportAuthorizedDevice) return false;

        // CM-24998 webmail 信任设备支持，从localStorage、cookie 格式化登录token 等信息
        var tokenInfo = loginDeviceStore.formatLoginToken(uid);
        if (tokenInfo != null) {
            tokenInfo.token && _$('.j-access-token').val(tokenInfo.token);
            tokenInfo.timestamp && _$('.j-timestamp').val(tokenInfo.timestamp);
            tokenInfo.signature && _$('.j-signature').val(tokenInfo.signature);
            tokenInfo.nonce && _$('.j-nonce').val(tokenInfo.nonce);
        }

        // CM-24998 webmail 信任设备支持，格式化设备信息
        var deviceInfo = loginDeviceStore.formatLoginDeviceInfo();
        if (deviceInfo != null) {
            // 由于二次认证不需要兼容 IE6/IE7，因此此处不需要引入 jquery-json 或任何 JSON shim 来处理
            _$('.j-device').val(JSON.stringify(deviceInfo));
        }
    }());

    // 触发表单submit 事件
    triggerLoginFormSubmit();
}

// 仅作提交，但不会触发登录操作，目的是根据当前表单参数刷新页面
function submitWithoutLogin() {
    _$('[name="action:login"]').remove();
    triggerLoginFormSubmit();
}

/**
 * 显示表单元素错误状态
 *
 * @param {jquery} $input 表单元素
 * */
function showInputError($input) {
    if ($input == null || !$input.length) return false;
    $input.focus().closest('.input-wrapper').prev().addClass('error');
}

/**
 * 显示错误信息
 *
 * @param {string} resultMsg 错误信息
 * */
function showErrMsgInfo(resultMsg) {
    _$('#warnOrErrDiv').removeClass('f-dn').addClass('errMsg').html(resultMsg);
}

/**
 * 清除错误信息
 * */
function cleanErrMsgInfo() {
    _$('#warnOrErrDiv').addClass('f-dn').removeClass('errMsg').html('');
}

/**
 * 格式化uid，暂时做以下两步：
 * 1. "。" ->"."
 * 2. 清空 "@" 前后不必要的空格
 *
 * @param {string} uid 用户邮箱
 * @return {string}
 * */
function formatUid(uid) {
    if (typeof uid !== 'string' || !uid.length) {
        return '';
    }

    var periodRegExp = new RegExp('\\s*' + String.fromCharCode(0x3002) + '\\s*', 'g');
    return $.trim(uid.replace(/\s*@\s*/g, '@').replace(periodRegExp, '.'));
}

/**
 * 尝试生成域名后缀的uid
 * 如果uid 带后缀，直接返回
 * 如果uid 不带后缀，尝试获取domain 列表的值
 * 如果无domain 列表，则尝试查找默认域名
 * 如果找不到默认域名，只好原值返回
 *
 * @param {string} uid
 * @return {string}
 * */
function genUidWithDomain(uid) {
    var $domain;
    var domain;
    var domainPos;

    if (typeof uid !== 'string') uid = _$('#uid').val();
    if (!uid.length) return '';

    domainPos = uid.indexOf('@');
    if (domainPos === -1) {
        $domain = _$('#domain');
        if ($domain.length && (domain = $domain.val())) {
            uid = uid + '@' + domain;
        } else if (SYS_CONST.primaryDomain != null && SYS_CONST.primaryDomain.length) {
            uid = uid + '@' + SYS_CONST.primaryDomain;
        }
    }
    return uid;
}

/**
 * 检查uid 是否带域名后缀
 *
 * @param {string} uid
 * @return {string}
 * */
function checkUidWithDomain(uid) {
    if (typeof uid !== 'string') return false;
    return (uid.indexOf('@')) > -1;
}

/**
 * 转换url 的协议
 *
 * @param {string} url
 * @param {string} srcProtocol 原协议
 * @param {string} dstProtocol 目标协议
 * return {string}
 * */
function translateProtocol(url, srcProtocol, dstProtocol) {
    var port = location.port,
        portinfo, // protocol,port
        protocol;
    // 记住当前非标准端口，切换http和https时可以加上
    if (port !== '') {
        Cookie.set(cookieNames.portinfo, location.protocol + ',' + port, {expires : 1, path : '/'});
    }

    // url = http(s)://host:port/...
    // url = http(s)://host/...
    // url = /...
    if (url.charAt(0) === '/') {
        // absolute location (but not absolute url)
        if (location.protocol + '//' !== dstProtocol) {
            port = '';
            portinfo = Cookie.get(cookieNames.portinfo) || '';
            protocol = portinfo.split(',')[0];

            if (protocol + '//' === dstProtocol) {
                port = portinfo.split(',')[1];
            }
            return dstProtocol + location.hostname + (port ? ':' + port : '') + url;
        }
        return url;
    }
    // TODO???: 不是很明白这里的用法，按照index.jsp的逻辑页面必然会出现转发，form action不会出现绝对地址的情况
    if (url.substring(0, srcProtocol.length).toLowerCase() === srcProtocol) {
        var pathStartAt = url.indexOf('/', srcProtocol.length);
        var portStartAt = url.lastIndexOf(':', pathStartAt);
        if (pathStartAt > 0 && portStartAt > 0
            && url.substring(portStartAt + 1, pathStartAt).match(/^\d+$/)) {
            // etc. translate (http://host:port/...) to (http://host/...)
            return dstProtocol + url.substring(srcProtocol.length, portStartAt) + url.substring(pathStartAt);
        } else {
            // etc. translate (http://host/........) to (http://host/...)
            return dstProtocol + url.substring(srcProtocol.length);
        }
    }

    return url;
}

/**
 * 摇晃表单元素
 *
 * @param {object} inp 需要摇晃的元素，jquery 类型DOM 集合
 * */
function shakeInput (inp) {
    var $panel = inp.parents('.u-form-item');
    if (!$.support.leadingWhitespace) {
        var offset = $panel.offset() - $panel.width();
        var x = offset.left;
        var y = offset.top;
        for (var i = 1; i <= 5; i++) {
            if (i % 2 === 0) {
                $panel.animate({left: '+6px'}, 80);
            } else {
                $panel.animate({left: '-6px'}, 80);
            }
        }
        $panel.animate({left: 0}, 150);
        $panel.offset({top: y, left: x});
    } else {
        $panel.addClass('animated shake');
    }
}

// 生成扫码登录二维码
function createQRCode() {
    var container = $('.QRCodeImage .wrapper');
    if (container.children().length === 0) {
        new QRCode(container[0], {
            text: genQRScanUrl(SYS_CONST.appScanLogin.tempSession), // 二维码内容
            width: 100,
            height: 100,
            colorDark : '#000000',
            colorLight : '#ffffff',
            correctLevel : QRCode.CorrectLevel.H
        });
    }
}

// 扫码登录消息订阅
function subscribeQRLoginMsg() {
    var pollUrl = '../getProcessStatus.jsp?sid=' + SYS_CONST.appScanLogin.tempSession;
    var socketTopic = 'onstat/mail/$sid$/op_app_qrcode_login'
            .replace('$sid$', SYS_CONST.appScanLogin.tempSession);
    var container = $('.QRCodeImage');
    var poll = container.data('poll');
    // 低版本浏览器只是用轮询方式
    // 高版本浏览器推送和轮询并存，当推送有返回结果时，停止轮询
    if (!poll) {
        poll = new PollStore({
            topic: pollUrl,
            successCallback: _pollSuccessCallback,
            errorCallback: _pollErrorCallback
        }).subscribe();

        if ('WebSocket' in window) {
            WsStore.subscribe(socketTopic, _socketSuccessCallback, {
                io: io,
                host: SYS_CONST.appScanLogin.host,
                authMeta: {
                    'sid': SYS_CONST.appScanLogin.tempSession,
                    'TmpSes': 1,
                    'ClientId': 'webmail:' + SYS_CONST.appScanLogin.tempSession
                }
            });
        }
        container.data('poll', poll);
    }

    function _socketSuccessCallback(result) {
        poll && poll.unSubscribe();
        _pollSuccessCallback(result);
    }

    function _pollSuccessCallback(result) {
        var payload = result.payload || {};
        updateQRLoginContainer(payload.status);

        if (payload.status === 'appVerify') {
            _setUserAvatar(payload.avatar, payload.gender);
            _setLoggedUsername(payload.trueName, payload.email);
        }

        if (payload.status === 'final') {
            poll && poll.unSubscribe();
            WsStore && WsStore.unSubscribe();
            // 延迟跳转
            setTimeout(function() {
                location.href = genLoginRedirectUrl(payload.sid, payload.cookiecheck);
            }, 500);
        }
    }

    function _pollErrorCallback(data) {
        data = data || {};
        if (data.code === 'FA_INVALID_SESSION') {
            updateQRLoginContainer('loginFail');
        }
    }

    // 设置用户头像
    function _setUserAvatar(avatar, gender) {
        gender = gender || '0';
        var defaultUrl = 'assets/@project.revision@/images/' + (gender === '0' ? 'man.png' : 'woman.png');
        $('.headImage img').attr('src', avatar || defaultUrl);
    }

    // 设置已登录用户的trueName/email
    function _setLoggedUsername(trueName, email) {
        $('.headImageArea .loggedUsername').html(trueName || email);
    }
}

// 更新二维码登录容器
function updateQRLoginContainer(className) {
    if (!className) {
        return false;
    }
    $('.j-qr-code-login').attr('curstatus', function(i, val) {
        val = val || '';
        if (val !== className) {
            $(this).toggleClass(val + ' ' + className);
            return className;
        }
        return val;
    });
}

function genUrlPrefix() {
    return [location.protocol, '//', location.host, '/@context.name@/'].join('');
}

function genQRScanUrl(sid) {
    return [genUrlPrefix(), 'qr/', sid].join('');
}

function genLoginRedirectUrl(sid, cookiecheck) {
    return [genUrlPrefix(), 'XT5/index.jsp?sid=', sid, '&Cookie.Coremail=', cookiecheck].join('');
}


/*****************
 ** WEBPACK FOOTER
 ** ./web.modules/coremail.framework/src/common/assets/index_cmxt50/js/XT5_login.js
 ** module id = 492
 ** module chunks = 14
 **/